import React from 'react';
import { OutlinedInput } from '@material-ui/core';

export default function InputNumber({errors, register, name, placeholder, minLength, required = true}) {
    return (
        <>
            <OutlinedInput
                fullWidth
                placeholder={placeholder}
                name={name}
                {...register(name, {
                    minLength: {
                        value: minLength,
                        message: `Mínimo ${minLength} carácteres`,
                    },
                    required: {
                        value: required,
                        message: 'Este campo es requerido',
                    },
                    pattern: {
                        value: /^(0|[1-9]\d*)$/,
                        message: 'El campo recibe sólo números',
                    },
                    
                })}
            />
            {errors[`${name}`] && (
                <p className="text-red-700  text-xs error-text" style={{ marginTop: '0px' }}>
                    {errors[`${name}`].message}
                </p>
            )}
        </>
    )
}